// ProjectSampleFileListPage.js
import { useEffect, useState } from "react";
import { getProjectSampleFiles } from "../../../Services/projectServices";
import { CommonTable, FileUploader, Spinner } from "../../../Components/Common";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../constants";
import InfiniteScroll from "react-infinite-scroll-component";
import { MdDownload } from "react-icons/md";
import { downloadUtil } from "../../../Utils/DownloadUtil";
import { sample_excel } from "../../../Assets";

const RESET_PAGINATION = { offset: 0, limit: 10, count: 0 };

const ProjectSampleFileListPage = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [pagination, setPagination] = useState(RESET_PAGINATION);

  const fetchFiles = async (
    offset = 0,
    limit = RESET_PAGINATION.limit,
    append = false
  ) => {
    if (offset === 0) setLoading(true);
    else setPaginationLoading(true);

    try {
      const response = await getProjectSampleFiles({ offset, limit });
      if (response.status === 200) {
        const { results, count } = response.data;
        setFiles((prev) => (append ? [...prev, ...results] : results));
        setPagination({ offset: offset + limit, limit, count });
      } else {
        toast.error(TOAST_MESSAGES.FILES_FETCHED_ERROR);
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.FILES_FETCHED_ERROR);
    } finally {
      setLoading(false);
      setPaginationLoading(false);
    }
  };

  const loadMoreFiles = () => {
    if (pagination.offset >= pagination.count) return;
    fetchFiles(pagination.offset, pagination.limit, true);
  };

  useEffect(() => {
    fetchFiles();
  }, []);

const handleDownload = async(fileUrl) => {
  try {
    await downloadUtil(fileUrl);
    toast.success(TOAST_MESSAGES.FILE_DOWNLOAD_SUCCESSFUL);
  } catch (error) {
    toast.error(TOAST_MESSAGES.FILE_DOWNLOAD_FAIL);
  }
}


  const handleRenderField = (key, rowData) => {
    if (key === "Actions") {
      return (
        <div key={rowData.id} className="flex space-x-2">
          <button
            onClick={() => handleDownload(rowData.file)}
            title="Download File"
          >
            <MdDownload
              size={20}
              className="text-secondary hover:text-blue-600"
            />
          </button>
        </div>
      );
    }

    if (key === "File Name") {
      const fileName = rowData.file?.split("/").pop().split("?")[0];
      return (
        <div>
        <a
          href={rowData.file}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
          title={fileName}
        >
          {fileName}
        </a>
        </div>
        
      );
    }

    if( key === "Description"){
      return (
        <div>
          {rowData?.description}
        </div>
      )
    }

    return rowData[key];
  };

  return (
    <div className="p-6 w-full">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-semibold">Document Template</h1>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-6 mt-8">
          <Spinner />
        </div>
      ) : (
        <div
          id="projectFileScrollDiv"
          className="h-[70vh] overflow-x-hidden overflow-y-scroll thin-scrollbar p-2"
        >
          <InfiniteScroll
            dataLength={files.length}
            next={loadMoreFiles}
            hasMore={pagination.offset < pagination.count}
            scrollableTarget="projectFileScrollDiv"
            loader={
              paginationLoading && (
                <div className="flex justify-center py-2">
                  <Spinner size={3} />
                </div>
              )
            }
          >
            <CommonTable
              tableColumns={["File Name", "Description", "Actions"]}
              tableRows={files}
              renderField={handleRenderField}
              className={"border-2 shadow-md text-md"}
              headerClassName={"sticky"}
            />
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};

export default ProjectSampleFileListPage;
